module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/video-preview-d0e8f6b40cb53e797943465bb92e19e5.jpg";